import InscricaoDesconto from "@/Models/Domain/Viagem/Inscricao/InscricaoDesconto";
import { useInscricaoDescontoDesativar } from "@/Services/Domain/Viagem/Inscricao/InscricaoDescontoService";
import { Button, ButtonProps, Popconfirm, PopconfirmProps } from "antd";
import { RenderFunction } from "antd/lib/_util/getRenderPropValue";
import { AxiosResponse } from "axios";
import { ReactNode } from "react";

interface IInscricaoDescontoDesativarPopconfirmProps extends Omit<PopconfirmProps, "title" | "description"> {
    inscricaoDesconto:InscricaoDesconto;
    onSuccess?:(response:AxiosResponse<void, any>, input:InscricaoDesconto) => void;
    title?:ReactNode | RenderFunction;
    description?:ReactNode | RenderFunction;
    openButtonProps?:ButtonProps;
}

export default function InscricaoDescontoDesativarPopconfirm({
    inscricaoDesconto,
    onSuccess,
    title,
    openButtonProps,
    description,
    destroyTooltipOnHide,
    children,
    ...props
}:IInscricaoDescontoDesativarPopconfirmProps) {
    title = title === undefined ? "Remover desconto" : title;
    description = description === undefined ? "Tem certeza de que deseja remover este desconto?" : description;
    destroyTooltipOnHide = destroyTooltipOnHide ?? true;

    const {
        mutate,
        isPending
    } = useInscricaoDescontoDesativar({
        onSuccess(data, variables, context) {
            onSuccess?.(data, variables);
        },
    });
    
    return <Popconfirm
        {...props}
        title={title}
        description={description}
        destroyTooltipOnHide={destroyTooltipOnHide}
        onConfirm={() => mutate(inscricaoDesconto)}
        okButtonProps={{
            loading : isPending
        }}
    >
        {
            !!children || <Button
                {...openButtonProps}
                type={openButtonProps?.type ?? 'primary'}
                size={openButtonProps?.size ?? 'small'}
                danger={openButtonProps?.danger ?? true}
                style={{ 
                    ...openButtonProps?.style,
                    width : openButtonProps?.style?.width ?? "min-content" 
                }}
            >
                Remover
            </Button>
        }
    </Popconfirm>
}